"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMetricsPublisher = void 0;
/* istanbul ignore file */
var KatalMetrics = __importStar(require("@amzn/katal-metrics"));
var katal_metrics_driver_sushi_1 = __importDefault(require("@amzn/katal-metrics-driver-sushi"));
var metricsErrorHandler = function (err) {
    console.error(err);
};
var metricsDriver = new katal_metrics_driver_sushi_1.default.Builder()
    .withDomainRealm('prod', 'USAmazon')
    .withErrorHandler(metricsErrorHandler)
    .build();
var urlMatch = /([^?]+)/.exec(window.location.href);
var urlMetric = new KatalMetrics.Metric.String('url', urlMatch ? urlMatch[1] : window.location.href);
urlMetric.truncate = true;
var metricsContext = new KatalMetrics.Context.Builder()
    .withSite('KatalLoggerInternalMetrics')
    .withServiceName('KatalLogger')
    .addRelatedMetrics(urlMetric)
    .build();
var initialMetricsPublisher = new KatalMetrics.Publisher(metricsDriver, metricsErrorHandler, metricsContext);
exports.createMetricsPublisher = function (methodName) {
    return initialMetricsPublisher.newChildActionPublisherForMethod(methodName);
};
//# sourceMappingURL=katal-metrics.js.map